import React, {useState, useEffect, useContext} from 'react'
import { FirebaseContext } from '../../Services/firebase'
import { TextField, Button, Typography, Divider } from '@mui/material';

import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';


export default function DisplayChangeChoices(props) {

    const firebase = useContext(FirebaseContext)
    
    const [Day, setDay] = useState([]);

    const [formValues, setFormValues] = useState({
        Menu: '',
        Entry: '',
        Plat: '',
        Laitage: '',
        Dessert: '',
        Potage: '',
        PotageNbr: '',
        Brick: '',
        BrickNbr: '',
        Diner: '',
        Boule: '',
        Baguette: '',
        Nature: '',
        Complet: ''
    })

    React.useEffect(() => {
        if (props.content) {
            setFormValues({
                Menu: props.content.menu,
                Entry: props.content.entree,
                Plat: props.content.plat,
                Laitage: props.content.laitage,
                Dessert: props.content.dessert,
                Potage: props.content.potage,
                Brick: props.content.brick,
                Diner: props.content.diner,
                PotageNbr: props.content.potagenbr,
                BrickNbr: props.content.bricknbr,
                Boule: props.content.boule,
                Baguette: props.content.baguette,
                Nature: props.content.nature,
                Complet: props.content.complet,
            })
        }
    }, [props.content])

    const data = {
        date: props.content.date,
        menu: formValues.Menu,
        entree: formValues.Entry,
        plat: formValues.Plat,
        laitage: formValues.Laitage,
        dessert: formValues.Dessert,
        potage: formValues.Potage,
        brick: formValues.Brick,
        diner: formValues.Diner,
        potagenbr: formValues.PotageNbr,
        bricknbr: formValues.BrickNbr,
        boule: formValues.Boule,
        baguette: formValues.Baguette,
        nature: formValues.Nature,
        complet: formValues.Complet
    };

    const recapData = {
        date: props.content.date,
        customer: props.customer,
        menu: formValues.Menu,
        entree: formValues.Entry,
        plat: formValues.Plat,
        laitage: formValues.Laitage,
        dessert: formValues.Dessert,
        potage: formValues.Potage,
        brick: formValues.Brick,
        diner: formValues.Diner,
        potagenbr: formValues.PotageNbr,
        bricknbr: formValues.BrickNbr,
        boule: formValues.Boule,
        baguette: formValues.Baguette,
        nature: formValues.Nature,
        complet: formValues.Complet
    }

    useEffect(() => {
        const fetchMenuData = async () => {
            const querySnapshot = await firebase.getMenusDate(props.uid, props.week, props.day).get();

            const menuDataPromises = querySnapshot.docs.map(doc =>
                firebase.getMenusContent(props.uid, props.week, props.day, doc.id).get(),
            );

            const menuDataDocs = await Promise.all(menuDataPromises);

            const menuData = menuDataDocs.map(doc => doc.data());

            setDay(menuData[0]);
        };
        fetchMenuData()
    }, [firebase, props.day, props.uid, props.week]);


    const handleInputChange = ({ target: { name, value } }) => {
        const newState = { ...formValues, [name]: value };

        switch (name) {
            case 'BrickNbr':
                if (Number(value) > 0) {
                    newState.Brick = Day.brick;
                } else if (Number(value) === 0) {
                    delete newState.Brick;
                }
                break;
            case 'PotageNbr':
                if (Number(value) > 0) {
                    newState.Potage = Day.potage;
                } else if (Number(value) === 0) {
                    delete newState.Potage;
                }
                break;
            default:
                break;
        }
        setFormValues(newState);
    };

    const cleanData = (data) => {
        return Object.fromEntries(
          Object.entries(data).filter(([_, value]) => value !== undefined && value !== null && value !== '')
        );
    };

    const handleChange = e => {
        setDay({...Day, [e.target.id]: e.target.value})
    }

    const handleDelete = async () => {
        try {
            await Promise.all([
                firebase.getSelectedChoice(props.uid, props.customer, props.week, props.day, props.choice).delete(),
                firebase.getRecap(props.uid, props.week, props.day, props.choice).delete(),
            ]);
            alert('Le menu a correctement été supprimé');
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        } catch (error) {
            console.error(error);
        }
    };

    const saveChanges = async () => {
        const filteredData = cleanData(data);
        const recapFilteredData = cleanData(recapData);

        try {
            await firebase.newCustomerChoice(
                props.uid,
                props.week,
                props.customer,
                props.day,
                filteredData,
                props.choice
            );
            await firebase.newRecap(
                props.uid,
                props.week,
                props.day,
                recapFilteredData,
                props.choice
            );

            alert(`La modification de ce jour pour le client : ${props.customer} a bien été enregistrée`);
            props.onActionComplete();
        } catch (error) {
            alert(error.message);
        }
    };

    const getOptions = (type) => {
        const prefix = {
            Entry: 'entree',
            Plat: 'plat',
            Laitage: 'laitage',
            Dessert: 'dessert'
        }[type];
        return formValues.Menu ? [
            Day[`${prefix}${formValues.Menu.replace('Menu', '')}`],
            Day[`${prefix}${formValues.Menu.replace('Menu', '')}O1`],
            Day[`${prefix}${formValues.Menu.replace('Menu', '')}O2`]
        ].filter(Boolean) : [];
    };
    
    return (
        <div style={{display: "flex", flexDirection: "row", width: "100%", justifyContent: "space-between", border: "1px solid grey", padding: "10px", borderRadius: "5px"}}>
            <div style={{display: "flex", flexDirection: "column", width: "20vw"}}>
                <TextField disabled id="date" label="date" type="date" value={props.content.date} sx={{ width: 220 }} InputLabelProps={{shrink: true,}} onChange={handleChange} size="small"/>
                <InputLabel id="demo-simple-select-label">Menu</InputLabel>
                <Select
                labelId="demo-simple-select-label"
                id="menu"
                value={formValues.Menu}
                label="menu"
                onChange={handleInputChange}
                name="Menu"
                >
                    <MenuItem value="MenuA">Menu A</MenuItem>
                    <MenuItem value="MenuB">Menu B</MenuItem>
                    <MenuItem value="MenuD">Menu diabétique</MenuItem>
                    <MenuItem value="MenuH">Menu haché</MenuItem>
                    <MenuItem value="MenuSS">Menu sans sel</MenuItem>
                    <MenuItem value="MenuSV">Menu sans viande</MenuItem>
                    <MenuItem value="MenuSP">Menu sans poisson</MenuItem>
                </Select>
                <InputLabel id="demo-simple-select-label">Entrée</InputLabel>
                <Select
                    name="Entry"
                    value={formValues.Entry}
                    onChange={handleInputChange}
                    label="Entrée"
                    displayEmpty
                >
                    {getOptions('Entry').map((entry, index) => (
                        <MenuItem key={index} value={entry}>
                        {entry}
                        </MenuItem>
                    ))}
                </Select>
                <InputLabel id="demo-simple-select-label">Plat</InputLabel>
                <Select
                    name="Plat"
                    value={formValues.Plat}
                    onChange={handleInputChange}
                    label="Plat"
                    displayEmpty
                >
                    {getOptions('Plat').map((plat, index) => (
                        <MenuItem key={index} value={plat}>
                        {plat}
                        </MenuItem>
                    ))}
                </Select>
                <InputLabel id="demo-simple-select-label">Laitage</InputLabel>
                <Select
                    name="Laitage"
                    value={formValues.Laitage}
                    onChange={handleInputChange}
                    label="Laitage"
                    displayEmpty
                >
                {getOptions('Laitage').map((laitage, index) => (
                    <MenuItem key={index} value={laitage}>
                    {laitage}
                    </MenuItem>
                ))}
                </Select>
                <InputLabel id="demo-simple-select-label">Dessert</InputLabel>
                <Select
                    name="Dessert"
                    value={formValues.Dessert}
                    onChange={handleInputChange}
                    label="Dessert"
                    displayEmpty
                >
                {getOptions('Dessert').map((dessert, index) => (
                    <MenuItem key={index} value={dessert}>
                    {dessert}
                    </MenuItem>
                ))}
                </Select>
                <TextField disabled label="Potage" type="text" value={formValues.Potage} sx={{ width: '100%' }} InputLabelProps={{shrink: true,}} size="small" style={{marginTop: "1vh"}} name="Potage" onChange={handleInputChange}/>
                <TextField disabled multiline rows={2} label="Diner léger" type="text" value={formValues.Diner} sx={{ width: '100%' }} InputLabelProps={{shrink: true,}} size="small" style={{marginTop: "1vh"}} name="Diner" onChange={handleInputChange}/>
            </div>
            <Divider orientation="vertical" flexItem/>
            <div style={{display: "flex", flexDirection: "column"}}>
                <div style={{display: "flex", flexDirection: "column", marginTop: "10px"}}>
                    <div style={{ display: "flex", flexDirection: "column", marginRight: "20px", gap: "10px"}}>
                        <Typography variant="h6" style={{marginBottom: "10px"}}>Potages & briques</Typography>
                        <div style={{ display: "flex", flexDirection: "row", marginRight: "20px", alignItems: "center", gap: "10px"}}>
                            <Select
                            labelId="demo-select-small-label"
                            id="potagenbr"
                            name="PotageNbr"
                            value={formValues.PotageNbr}
                            label="PotageNbr"
                            onChange={handleInputChange}
                            style={{ height: 30, width: 60 }}
                            >
                                <MenuItem value="0">0</MenuItem>
                                <MenuItem value="1">1</MenuItem>
                                <MenuItem value="2">2</MenuItem>
                                <MenuItem value="3">3</MenuItem>
                                <MenuItem value="4">4</MenuItem>
                                <MenuItem value="5">5</MenuItem>
                                <MenuItem value="6">6</MenuItem>

                            </Select>
                            <InputLabel id="demo-simple-select-label">Nombre de potage</InputLabel>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", marginRight: "20px", alignItems: "center", gap: "10px"}}>
                            <Select
                            labelId="demo-select-small-label"
                            id="bricknbr"
                            name="BrickNbr"
                            value={formValues.BrickNbr}
                            label="BrickNbr"
                            onChange={handleInputChange}
                            style={{ height: 30, width: 60 }}
                            >
                                <MenuItem value="0">0</MenuItem>
                                <MenuItem value="1">1</MenuItem>
                                <MenuItem value="2">2</MenuItem>
                                <MenuItem value="3">3</MenuItem>
                                <MenuItem value="4">4</MenuItem>
                                <MenuItem value="5">5</MenuItem>
                                <MenuItem value="6">6</MenuItem>
                            </Select>
                            <InputLabel id="demo-simple-select-label">Nombre de briques</InputLabel>
                        </div>
                    </div>
                    <Typography variant="h6" style={{marginBottom: "10px", marginTop: "20px"}}>Potages & briques</Typography>
                    <div style={{ display: "flex", flexDirection: "column", marginRight: "20px", gap: "10px"}}>
                        <div style={{ display: "flex", flexDirection: "row", marginRight: "20px", alignItems: "center", gap: "10px"}}>
                            <Select
                            labelId="demo-select-small-label"
                            id="boule"
                            name="Boule"
                            value={formValues.Boule}
                            label="Boule"
                            onChange={handleInputChange}
                            style={{ height: 30, width: 60 }}
                            >
                                <MenuItem value="0">0</MenuItem>
                                <MenuItem value="1">1</MenuItem>
                                <MenuItem value="2">2</MenuItem>
                                <MenuItem value="3">3</MenuItem>
                            </Select>
                            <InputLabel id="demo-simple-select-label">Boule</InputLabel>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", marginRight: "20px", alignItems: "center", gap: "10px"}}>
                            <Select
                            labelId="demo-select-small-label"
                            id="baguette"
                            name="Baguette"
                            value={formValues.Baguette}
                            label="Baguette"
                            onChange={handleInputChange}
                            style={{ height: 30, width: 60 }}
                            >
                                <MenuItem value="0">0</MenuItem>
                                <MenuItem value="1">1</MenuItem>
                                <MenuItem value="2">2</MenuItem>
                                <MenuItem value="3">3</MenuItem>
                            </Select>
                            <InputLabel id="demo-simple-select-label">Baguette</InputLabel>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", marginRight: "20px", alignItems: "center", gap: "10px"}}>
                            <Select
                            labelId="demo-select-small-label"
                            id="nature"
                            name="Nature"
                            value={formValues.Nature}
                            label="Pain de mie nature"
                            onChange={handleInputChange}
                            style={{ height: 30, width: 60 }}
                            >
                                <MenuItem value="0">0</MenuItem>
                                <MenuItem value="1">1</MenuItem>
                                <MenuItem value="2">2</MenuItem>
                                <MenuItem value="3">3</MenuItem>
                            </Select>
                            <InputLabel id="demo-simple-select-label">Pain de mie nature</InputLabel>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", marginRight: "20px", alignItems: "center", gap: "10px"}}>
                            <Select
                            labelId="demo-select-small-label"
                            id="complet"
                            name="Complet"
                            value={formValues.Complet}
                            label="Pain de mie complet"
                            onChange={handleInputChange}
                            style={{ height: 30, width: 60 }}
                            >
                                <MenuItem value="0">0</MenuItem>
                                <MenuItem value="1">1</MenuItem>
                                <MenuItem value="2">2</MenuItem>
                                <MenuItem value="3">3</MenuItem>
                            </Select>
                            <InputLabel id="demo-simple-select-label">Pain de mie complet</InputLabel>
                        </div>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", gap: "10px", marginTop: "auto"}}>
                    <Button variant="outlined"  className="MuiButton-error" style={{width: "7vw", marginTop: "1vh"}} onClick={handleDelete}>Supprimer</Button>
                    <Button variant="contained" color="success" style={{width: "7vw", marginTop: "1vh"}} onClick={saveChanges}>Enregistrer</Button>
                </div>
            </div>
        </div>
        
    )
}